<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="headline">
        Editar Anotação
        <v-spacer></v-spacer>
        <v-btn @click="close" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-textarea
          v-model="annotation_description"
          label="Descrição"
          auto-grow
          outlined
        >
        </v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">Cancelar</v-btn>
        <v-btn color="primary" @click="updateAnnotations()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { update } from "@/services/annotations";
import ToastsMixin from "@/mixins/ToastsMixin.vue";
export default {
  name: "EditCommentAnnotation",
  props: {},
  mixins: [ToastsMixin],
  data() {
    return {
      dialog: false,
      annotation_description: "",
      annotationId: null,
    };
  },
  methods: {
    open(annotationId, annotation) {
      this.annotationId = annotationId;
      this.annotation_description = annotation;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    async updateAnnotations() {
      try {
        const response = await update(this.annotationId, {
          message: this.annotation_description,
        });
        this.$emit("update:annotation", response.data);
        this.toastSuccess("Anotação atualizada com sucesso!");
        this.close();
      } catch (error) {
        const errorMessage = error.response?.data?.message || error;
        this.toastError(errorMessage);
      }
    },
  },
};
</script>
